/**
 * 
 * Компонент ввода телефона с выбором кода страны
 * 
 */

window.ABInputPhone = {
    countriesList: [
        {
            code: 'rus',
            title: 'Россия',
            phoneCode: '+7',
            mask: '+7  (X99)  999-99-99',
        },
        {
            code: 'kaz',
            title: 'Казахстан',
            phoneCode: '+7',
            mask: '+7 9999 999999',
        },
        {
            code: 'bel',
            title: 'Беларусь',
            phoneCode: '+375',
            mask: '+375 99 9999999',
        },
        /*{
            code: 'uzb',
            title: 'Узбекистан',
            phoneCode: '+998',
            mask: "+\\9\\98 99 999 99 99",
            placeholder: '+998 00 000 00 00',
        },*/
        {
            code: 'arm',
            title: 'Армения',
            phoneCode: '+374',
            mask: '+374 99 999999',
        },
        /*{
            code: 'cze',
            title: 'Чехия',
            phoneCode: '+420',
            mask: '+420 999 999 999',
        },
        {
            code: 'usa',
            title: 'США',
            phoneCode: '+1',
            mask: '+1 999 999 9999',
        },*/
        {
            code: 'isr',
            title: 'Израиль',
            phoneCode: '+972',
            mask: '+\\972 99 999 9999',
            placeholder: '+972 00 000 0000',
        },
        {
            code: 'gbr',
            title: 'Великобритания',
            phoneCode: '+44',
            mask: '+44 9999 999999',
        },
        {
            code: 'can',
            title: 'Канада',
            phoneCode: '+1',
            mask: '+1 999 999 9999',
        },
        {
            code: 'swe',
            title: 'Швеция',
            phoneCode: '+46',
            mask: '+46 99 999 99 99',
        },
        {
            code: 'fra',
            title: 'Франция',
            phoneCode: '+33',
            mask: '+33 9 99 99 99 99',
        },
        {
            code: 'tur',
            title: 'Турция',
            phoneCode: '+90',
            mask: '+\\90 999 999 99 99',
            placeholder: '+90 000 000 00 00',
        },
        {
            code: 'tha',
            title: 'Тайланд',
            phoneCode: '+66',
            mask: '+66 99 999 9999',
        },
        /*{
            code: 'uae',
            title: 'Объединённые Арабские Эмираты',
            phoneCode: '+971',
            mask: '+\\971 99 999 9999',
            placeholder: '+971 00 000 0000',
        },*/
        {
            code: 'kir',
            title: 'Киргизия',
            phoneCode: '+996',
            mask: '+\\9\\96 999 999 999',
            placeholder: '+996 000 000 000',
        },
        {
            code: 'geo',
            title: 'Грузия',
            phoneCode: '+995',
            mask: '+\\9\\95 999 99 99 99',
            placeholder: '+995 000 00 00 00',
        },
        {
            code: 'aze',
            title: 'Азербайджан',
            phoneCode: '+994',
            mask: '+\\9\\94 99 999 99 99',
            placeholder: '+994 00 000 00 00',
        },
        {
            code: 'taj',
            title: 'Таджикистан',
            phoneCode: '+992',
            mask: '+\\9\\92 999 99 9999',
            placeholder: '+992 000 00 0000',
        },
        {
            code: 'mol',
            title: 'Молдова',
            phoneCode: '+373',
            mask: '+373 999 99 999',
            placeholder: '+373 000 00 000',
        },
        {
            code: 'ser',
            title: 'Сербия',
            phoneCode: '+381',
            mask: '+381 99 9999999',
            placeholder: '+381 00 0000000',
        },
        {
            code: 'fin',
            title: 'Финляндия',
            phoneCode: '+358',
            mask: '+358 99 9999999',
            placeholder: '+358 00 0000000',
        },
        {
            code: 'ger',
            title: 'Германия',
            phoneCode: '+49',
            mask: '+4\\9 9999 9999999',
            placeholder: '+49 0000 0000000',
        },
        {
            code: 'aus',
            title: 'Австрия',
            phoneCode: '+43',
            mask: '+43 999 999999',
            placeholder: '+43 000 000000',
        },
        {
            code: 'ned',
            title: 'Нидерланды',
            phoneCode: '+31',
            mask: '+31 99 999 9999',
            placeholder: '+31 00 000 0000',
        },
        {
            code: 'spa',
            title: 'Испания',
            phoneCode: '+34',
            mask: '+34 999 99 99 99',
            placeholder: '+34 000 00 00 00',
        },
        {
            code: 'ita',
            title: 'Италия',
            phoneCode: '+39',
            mask: '+3\\9 999 999 9999',
            placeholder: '+39 000 000 0000',
        },
        {
            code: 'lit',
            title: 'Литва',
            phoneCode: '+370',
            mask: '+370 999 99999',
            placeholder: '+370 000 00000',
        },
        {
            code: 'pol',
            title: 'Польша',
            phoneCode: '+48',
            mask: '+48 999 999 999',
            placeholder: '+48 000 000 000',
        },
        {
            code: 'cyp',
            title: 'Кипр',
            phoneCode: '+357',
            mask: '+357 99 999999',
            placeholder: '+357 00 000000',
        },
    ],
    
    /**
     * Инициализирует компонент
     *
     * @method init
     * @param {HTMLElement} elem - корневой блок .js-input-phone, может иметь атрибут data-countries-list - список кодов нужных стран в формате `code1,code2,code3`
     */
    init: function(elem) {
        const select = elem.querySelector('[data-role="phone-input-select"]');
        const input = elem.querySelector('[data-role="phone-input-input"]');
        const inputCode = elem.querySelector('[data-role="phone-input-code"]');
        const flag = elem.querySelector('[data-role="phone-input-flag"]');
        let list;
        
        let usedMaskCode;
        
        let countriesListFiltered = window.ABInputPhone.countriesList;
        if (elem.dataset.countriesList) {
            const codesToFilter = elem.dataset.countriesList.split(',').map(item => item.trim());
            countriesListFiltered = window.ABInputPhone.countriesList.filter(country => {
                return codesToFilter.indexOf(country.code) !== -1;
            });
        }
        
        let countriesListHTML = '<div class="input-phone__list" data-role="phone-input-list"><div class="input-phone__list-inner">';
        countriesListFiltered.forEach(countryElem => {
            countriesListHTML +=
                `<div class="input-phone__list-item" data-role="phone-input-list-item" data-country-code="${countryElem.code}">
                    <span class="input-phone__flag input-phone__list-item-flag" data-country-code="${countryElem.code}"></span>
                    <span class="input-phone__list-item-title">${countryElem.title}</span>
                    <span class="input-phone__list-item-code">${countryElem.phoneCode}</span>
                </div>`;
        });
        countriesListHTML += '</div></div>';
        
        function setMask(code) {
            const $input = $(input);
            const countryData = countriesListFiltered.find(country => country.code === code);
            const options = {
                mask: countryData.mask,
                placeholder: "0",
                clearMaskOnLostFocus: true,
                showMaskOnFocus: true,
                showMaskOnHover: false,
                oncleared: ()=> {
                    $input.addClass('_gray');
                    $input.val();
                }
            };
            
            if (code === 'rus') {
                options.definitions = {
                    'X': {
                        validator: "[49]"
                    }
                };
            }
            
            inputCode.value = usedMaskCode = code;
            
            flag.dataset.countryCode = code;
            
            input.placeholder = (countryData.placeholder) ? countryData.placeholder : countryData.mask.replace(/[X9]/g, '0');
            $input.inputmask(options);
        }
        
        if (countriesListFiltered.length === 1) {
            select.dataset.state = 'disabled';
            
        } else {
            $(select).tooltipster({
                arrow: false,
                content: countriesListHTML,
                contentAsHTML: true,
                delay: 100,
                debug: false,
                interactive: true,
                trigger: 'custom',
                triggerClose: {
                    click: true,
                    tap: true
                },
                triggerOpen: {
                    click: true,
                    tap: true
                },
                theme: 'tooltipster-input-phone',
                viewportAware: false,
                
                functionPosition: function(instance, helper, position) {
                    const rect = input.getBoundingClientRect();
                    position.coord.top = rect.top + input.offsetHeight + 4;
                    position.coord.left = rect.left;
                    return position;
                },
                
                functionReady: function(instance, helper) {
                    instance._$origin[0].dataset.state = 'active';
                    instance._$tooltip[0].style.width = input.offsetWidth + 'px';
                    
                    list = instance._$tooltip[0].querySelector('[data-role="phone-input-list"]');
                    if (list) {
                        new SimpleBar(list);
                        list.querySelector('[data-role="phone-input-list-item"][data-country-code="' + (usedMaskCode || countriesListFiltered[0].code) + '"]').dataset.state = 'active';
                    }
                    
                    const options = instance._$tooltip[0].querySelectorAll('[data-role="phone-input-list-item"]');
                    options.forEach(optionElem => {
                        optionElem.addEventListener('click', function(event) {
                            event.preventDefault();
                            
                            if (optionElem.dataset.state === 'active') {
                                return;
                            }
                            
                            $(input).trigger('unmask');
                            input.value = '';
                            
                            $(select).tooltipster('close');
                            
                            setMask(optionElem.dataset.countryCode);
                            
                            if (list) {
                                list.querySelector('[data-role="phone-input-list-item"][data-state="active"]').dataset.state = '';
                                list.querySelector('[data-role="phone-input-list-item"][data-country-code="' + optionElem.dataset.countryCode + '"]').dataset.state = 'active';
                            }
                        });
                    });
                },
                
                functionAfter: function(instance, helper) {
                    instance._$origin[0].dataset.state = '';
                }
            });
        }
        
        
        // Инит
        
        setMask(inputCode.value || countriesListFiltered[0].code);
    }
};

document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.js-input-phone').forEach(elem => {
        window.ABInputPhone.init(elem);
    })
});
